<template>
  <VModal :showing="showing" container-classes="max-w-screen-md" @update:showing="$emit('update:showing', $event)">
    <h2 class="text-xl mb-8 mr-8 truncate">Delete {{ deck.title }}?</h2>
    <p class="text-gray-800 font-light">This 3D Presentation will be removed permanently. This action cannot be reversed!</p>
    <p class="text-gray-800 font-light">Are you sure you want to continue?</p>
    <div class="flex flex-row gap-4 mt-8 w-full justify-end">
      <VButton class="w-42" data-testid="cancel-button" @click="$emit('update:showing', false)">Cancel</VButton>
      <VButton class="w-42" variant="danger" data-testid="delete-button" @click="$emit('delete-deck')">Confirm</VButton>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import type { Deck } from '@/entities/deck'
import type { EditDeck } from '@/composables/useEditDeck'

defineProps({
  deck: {
    type: Object as PropType<DeepReadonly<EditDeck>>,
    required: true,
  },
  showing: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['delete-deck', 'update:showing'])
</script>
